import { render } from "./ImportTypeCard.vue?vue&type=template&id=49e49128&scoped=true"
import script from "./ImportTypeCard.vue?vue&type=script&lang=js"
export * from "./ImportTypeCard.vue?vue&type=script&lang=js"

import "./ImportTypeCard.vue?vue&type=style&index=0&id=49e49128&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e49128"]])

export default __exports__